import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../loren-base-endpoints-service/loren-base-endpoints.service";

@Injectable({
  providedIn: "root",
})
export class LorenUsersEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  userInfo() {
    return `${this.getApiServerUrl()}/users/me`;
  }

  users() {
    return `${this.getApiServerUrl()}/users`;
  }

  password(userId: string) {
    return `${this.getApiServerUrl()}/users/${userId}/password`;
  }

  images(userId: number) {
    return `${this.getApiServerUrl()}/users/${userId}/images`;
  }

  userFeatures() {
    return `${this.getApiServerUrl()}/features`;
  }

  currentUserPrivileges() {
    return `${this.getApiServerUrl()}/current-user-privileges`;
  }

  assignGroupsToUser(userId: number) {
    return `${this.getApiServerUrl()}/users/${userId}/asset-group-access`;
  }
}
